import React, { useCallback } from 'react';
import analyticsService from '../../../helpers/analytics.service';
import { DownloadDocIcon } from '../../../images';
import { Button } from 'src/components/design-system/buttons';
import { EVENTS } from 'shared/constants/analytics';
import styles from './document-download.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { getFileExtension, getFileNameFromUrl } from 'shared/utils';

/**
 * @type {React.FC<{ knowledge: { id?: string, title?: string, link: string, type?: string, ownerIds?: string[], linked?: boolean } }>}
 */
const DocumentDownload = React.memo(({ knowledge = {} }) => {
  const { id, title, link, type, ownerIds } = knowledge;
  // Fall back to the file name from the link when there's no title, so we never render a
  // bare extension ("Download csv"). getFileNameFromUrl strips the extension, so re-append it.
  const baseName = title || getFileNameFromUrl(link);
  const fileName = [baseName, getFileExtension(link)].filter(Boolean).join('.');

  const lang = useSelector(getLang('KNOWLEDGE_EDITOR'));

  React.useEffect(() => {
    analyticsService.track(EVENTS.KNOWLEDGE_ITEMS.DOWNLOAD_FILE_IMPRESSION, {
      id,
      title,
      ownerIds,
      type,
      link,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDownload = useCallback(() => {
    analyticsService.track(EVENTS.KNOWLEDGE_ITEMS.DOWNLOAD_FILE, {
      id,
      title,
      ownerIds,
      type,
      link,
    });

    window.open(link);
  }, [id, link, ownerIds, title, type]);

  return (
    <div className={styles.box}>
      <img src={DownloadDocIcon} alt={'download'} className={styles.icon} />
      <p className={styles.text}>{lang.COMING_SOON}</p>
      <Button type="default" onClick={onDownload}>
        {`${lang.DOWNLOAD} ${fileName}`}
      </Button>
    </div>
  );
});

export { DocumentDownload };
